<template>
<div class="consulAddDialog">  
  <el-form ref="form" :model="form" label-width='150px' v-if="moduleShow2">
    <el-form-item label="交办组织">
      <el-select :disabled='readonlyjb' v-model="form.jbOrgName" placeholder="请选择" style='width:90.5%' @change="getFindConsultPersonList">
        <el-option
          v-for="(item, index) in ConsultOrgOption"
          :key="index"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select> 
    </el-form-item>
    <el-form-item label="交办负责人"> 
      <el-select :disabled='readonlyjbs' v-model="form.jbrName" placeholder="请选择" @change="jbrChange" style='width:90.5%'> 
        <el-option
          v-for="item in ConsultPersonOptions"
          :key="item.userId"
          :label="item.name"
          :value="item.userId">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="截止时间">
      <el-date-picker :disabled='readonlyjbs'
        style='width:90.5%'
        v-model="form.assignmentTime"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="工作要求">
      <el-input :disabled='readonlyjbs' v-model="form.jobRequirements" type="textarea" style='width:90.5%'></el-input>
    </el-form-item>
    <div class="queRenBtn">
      <el-button v-if='readonlyjbs!==true' type="primary" @click="onSave">确定</el-button>
      <el-button v-if='readonlyjbs!==true' @click="quXiao">取消</el-button>
    </div>
</el-form> 
</div>
  
</template>

<script>
import { post } from "@/api/requrestHttp";
import ViewAudit from "@/views/platform/gridding/communityIssueTitle/auditDialog.vue";
import ViewBanLi from "@/views/platform/gridding/communityIssueTitle/showBanLiDialog.vue";
import ViewJieGuo from "@/views/platform/gridding/communityIssueTitle/showJieGuoDialog.vue";
import ViewGongShi from "@/views/platform/gridding/communityIssueTitle/showGongShiDialog.vue";
import ViewPingYi from "@/views/platform/gridding/communityIssueTitle/showPingYiDialog.vue";
export default {
  props: ["ytid", "show", "readonlyjb"],
  components: { ViewAudit,ViewBanLi,ViewJieGuo,ViewGongShi,ViewPingYi },
  data() {
      return {
        readonlys:true,
        readonlyjbs:this.readonlyjb,
        readonlybl:false,
        readonlyjg:false,
        readonlygs:false,
        readonlypy:false,
        showJiaoBan: false,
        showBanLi: false,
        showJieGuo: false,
        showBanLiJiLu: false,
        showGongShi: false,
        showGongShiJiLu: false,
        showPingYi: false,
        id: this.ytid, 
        radio: '1',
        form: {
          jbr: '',
          jbOrg: '',
          assignmentTime: '',
          jobRequirements: ''
        },
        jbOrg:'',
        jbr: '',
        ConsultOrgOption: [],
        ConsultPersonOptions: [],
        addform: {},
        moduleShow1: false,
        moduleShow2: true,
        orgName: '',
        streetName: '',
        tableData1: [],
        xsytList: [
          { value: '1', label: '党小组、村(居)民组会议' },
          { value: '2', label: '群众通过电话或口头等方式' },
          { value: '3', label: '群众通过微信、QQ等方式提出' },
          { value: '4', label: '党员议事日' },
          { value: '5', label: '意见箱' },
          { value: '6', label: '包组干部收集到群众的需求' },
          { value: '7', label: '落实上级党委政府工作安排' },
          { value: '8', label: '其他' }
        ],
        xszjList: [ 
          { value: '1', label: '涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项' },
          { value: '2', label: '涉及1个村以上"两委"成员包组范围内1村(居)民组事项' },
          { value: '3', label: '涉及与本镇内1个村以上范围事项' },
          { value: '4', label: '涉及本镇以外其他镇的协商事项' },
        ],
        sureList: [
          { value: '0', label: '村"两委"会' },
          { value: '1', label: '扩大会' },
          { value: '2', label: '党员议事会' },
        ],
      }
  },
  watch: {
    // show(val) {
    //   if (!val) {
    //     this.resetData();
    //   }
    // }
  },
  methods: {
    issueCJ() { //信息采集
        console.log(this.ytid);
          this.moduleShow1 = true;
          this.moduleShow2 = false;
          this.moduleShow3 = false;
          this.moduleShow4 = false;
          this.moduleShow5 = false;
          this.moduleShow6 = false; 
      },
      jbinfo() {  //交办
          this.moduleShow1 = false;
          this.moduleShow2 = true;
          this.moduleShow3 = false;
          this.moduleShow4 = false;
          this.moduleShow5 = false;
          this.moduleShow6 = false;
      },
      blinfo() {//办理
          this.moduleShow1 = false;
          this.moduleShow2 = false;
          this.moduleShow3 = true;
          this.moduleShow4 = false;
          this.moduleShow5 = false;
          this.moduleShow6 = false;
      },
      blresult() { //结果
          this.moduleShow1 = false;
          this.moduleShow2 = false;
          this.moduleShow3 = false;
          this.moduleShow4 = true;
          this.moduleShow5 = false;
          this.moduleShow6 = false;
      },
      blpublicity() { //公示
          this.moduleShow1 = false;
          this.moduleShow2 = false;
          this.moduleShow3 = false;
          this.moduleShow4 = false;
          this.moduleShow5 = true;
          this.moduleShow6 = false;
      },
      blComment() { //评议
          this.moduleShow1 = false;
          this.moduleShow2 = false;
          this.moduleShow3 = false;
          this.moduleShow4 = false;
          this.moduleShow5 = false;
          this.moduleShow6 = true;
      },
      closeDialog() {
        this.$emit('closeViewJiaoban');
      },
      // 获取议题编号 街道 社区
      getOrgLevel(){
        console.log('909090')
        post("admin/user/info/getLoginUserInfo", {
            id: this.$store.state.id
          }).then(res => {
            this.orgName = res.content.user.orgName;
            this.streetName = res.content.user.streetName;
            console.log(res.content.user.orgName)
          });
      },
      getConsultFind(){
        this.form={}
        console.log(this.readonlyjb);
        console.log(this.ytid);
        post("admin/consult/info/findConsultById",{
          id: this.ytid,
        }).then(res => {
          this.form = res.content;
        })
      },
      onSave() {
        console.log(this.id) 
        post("/admin/consult/info/assignment",{
          ...this.form,
          id: this.ytid,
          approvalStatus:1
        }).then(res => {
          console.log(res);
          this.quXiao();
        })
      },
      quXiao() {
        this.$emit('close');
        this.ConsultOrgOption = []
        this.ConsultPersonOptions = []
      }, 
      getdata() { 
        this.form = {};
      },
      getFindConsultPersonList(value) {
        this.form.jbOrg = value
        this.form.jbr = ''
        post("admin/consulType/info/findConsultPersonList",{
          pageNo: 1,
          pageSize: 100,
          communityPerson:0,
          approvalStatus: 1,
          status: 0,
          consultOrgId:this.form.jbOrg,
        }).then(res => {
          this.ConsultPersonOptions = res.content.list
          console.log(this.ConsultPersonOptions);
        })
      },
      jbrChange(value){
        console.log(value);
        this.form.jbr = value
      },
      getListConsultOrg() {
        post("admin/consulOrg/info/listConsultOrg",{
          pageNo: 1,
          pageSize: 100, 
          status:0,
        }).then(res => {
          this.ConsultOrgOption = res.content.list;
        })
      },
    
  },
  mounted() {  
    this.jbinfo();
    this.getListConsultOrg();
    this.getConsultFind()
  }
}
</script>

<style lang="less" scoped>
.consulAddDialog {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  .qubtn{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  } 
  .qubtn :hover{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  }
  .qubtn_span{
      color:#409EFF; 
      margin-top:10px
  }

}
</style>